"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERWALTUNG_WRITE_ROLES = void 0;
const Roles_1 = require("../enums/Roles");
// WFM is the matrix-defined Verwaltung manager. Reads on Verwaltung reference pages
// (worktypes, channels, tasks, etc.) stay open to any authenticated Callmart user.
exports.VERWALTUNG_WRITE_ROLES = [Roles_1.Roles.CallmartWFM];
